import { GetAuthToken } from './GetAuthToken.js';
export async function LargeSet(reference, set, options = {}) {
  // Using the Firebase Rest API here instead of chunking the data allows us to write up to a 64MB (~60s of write time) set. This can be
  // increased to 256MB by setting our defaultWriteSizeLimit to "unlimited" (For more info see:
  // https://firebase.google.com/docs/reference/rest/database#section-param-writesizelimit). This should be plenty for now, but once writes
  // get bigger than this, we will need to re-evaluate.
  if (!options.authToken && !options.accessToken) {
    const res = await GetAuthToken();
    if (res.type == 'id_token') options.authToken = res.token;
    else if (res.type == 'access_token') options.accessToken = res.token;
  }
  // Build the url and set the appropriate query parameter.
  let url = `${reference.toString()}/.json?`;
  if (options.authToken) url += `auth=${options.authToken}`;
  else if (options.accessToken) url += `access_token=${options.accessToken}`;
  else throw new Error('Missing both id_token and access_token');
  // Perform the fetch.
  const res = await fetch(url, { method: 'PUT', body: JSON.stringify(set) });
  if (!res.ok) throw new Error(`Firebase REST API: ${res.status} ${res.statusText}`);
}
